import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, Text, Badge, Group, Stack, Anchor } from "@mantine/core";

export function TagSection({ title, items, colored = false, colorIndex= '0' }) {
  const palette = [
    { color: "blue", variant: "light" },   // bg-blue-100 text-blue-700 border
    { color: "green", variant: "light" },  // bg-green-100 text-green-700 border
    { color: "yellow", variant: "light" }, // bg-yellow-100 text-yellow-700 border
  ];

  // Generate href based on title
  const getHref = (item) => {
    const baseUrl = "/dashboard/#/members?";
    switch (title.toLowerCase()) {
      case "expertise":
        return `${baseUrl}expert_in=${encodeURIComponent(item)}`;
      case "skills":
        return `${baseUrl}skills=${encodeURIComponent(item)}`;
      case "industry":
        return `${baseUrl}industries=${encodeURIComponent(item)}`;
      default:
        return `${baseUrl}search=${encodeURIComponent(item)}`;
    }
  };

  // Get placeholder text based on title
  const getPlaceholderText = () => {
    switch (title.toLowerCase()) {
      case "expertise":
        return "No Expertise added";
      case "skills":
        return "No Skills added";
      case "industry":
        return "No Industry added";
      default:
        return "No items added";
    }
  };

  return (
    <Card shadow="none" radius="sm" withBorder aria-labelledby={`${title.toLowerCase()}-heading`} p="lg">
      <Text id={`${title.toLowerCase()}-heading`} fw={500} mb="sm">
        {title}
      </Text>
      <Stack spacing="sm" align="flex-start">
        {items && items.length > 0 ? (
          items.map((item) => (
            <Anchor
              key={item}
              href={getHref(item)}
              style={{ textDecoration: "none" }}
            >
              <Badge
                color={colored ? palette[colorIndex].color : "gray"}
                variant={colored ? palette[colorIndex].variant : "outline"}
                radius="sm"
                size="lg"
                style={{ cursor: "pointer" }}
              >
                {item}
              </Badge>
            </Anchor>
          ))
        ) : (
          <Text fs="italic">
            {getPlaceholderText()}
          </Text>
        )}
      </Stack>
    </Card>
  );
}
